import React from 'react';
import { routeMap } from './routes';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import './index.less';

export default function App() {
    return (
        <Router>
            <Switch>
                <Route exact path="/" render={() => <Redirect to="/login" />} />
                {routeMap.map(({path, Component, ...route})=>(
                    <Route
                        key={path}
                        path={path}
                    >
                        <Component />
                    </Route>
                ))}
            </Switch>
        </Router>
    )
}